<p-panel header="Service Fees for {{ _customerName }} ">
  <div class="pb-3">
    <organisation-select-list
      [minTextLength]="1"
      [selectedOrganisationId]="filterVal?.filters?.customerId?.value"
      (valueChange)="onTableOrganisationChange($event)"
      [organisationTypeId]="2"
    ></organisation-select-list>
  </div>
  <p-table
    #dt
    [columns]="cols"
    [value]="customerServiceFees?.items"
    selectionMode="single"
    (onRowSelect)="onRowSelect($event)"
    [paginator]="true"
    [rows]="5"
    [rowsPerPageOptions]="[5, 10, 20, 30]"
    [pageLinks]="3"
    lazy="true"
    [responsive]="true"
    [totalRecords]="customerServiceFees?.total"
    (onLazyLoad)="onGridLazyLoad($event)"
    [first]="filterVal.first"
    [sortField]="filterVal.sortField"
    [sortOrder]="filterVal.sortOrder"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.sortField">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          {{ rowData[col.field] }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="text-align: right" class="pt-2">
    <button
      type="button"
      pButton
      icon="fa fa-plus"
      (click)="showDialogToAdd()"
      label="Add"
      [disabled]="isReadonly"
    ></button>
  </div>
</p-panel>

<p-dialog
  header="Customer Service Fee Details"
  [(visible)]="displayDialog"
  [responsive]="true"
  showEffect="fade"
  [modal]="true"
  [style]="{ width: '600px' }"
>
  <div class="ui-g ui-fluid" *ngIf="customerServiceFee">
    <div class="ui-g-12" *ngIf="!customerId">
      <div class="ui-g-4">
        <label for="feeName">Customer</label>
      </div>
      <div class="ui-g-8">
        <organisation-select-list
          [minTextLength]="1"
          [organisationTypeId]="2"
          (valueChange)="onFormOrganisationChange($event)"
          [selectedOrganisationId]="customerServiceFee?.customerId"
        ></organisation-select-list>
      </div>
    </div>
    <input pInputText type="hidden" id="customerId" [(ngModel)]="customerServiceFee.customerId" />
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="name" title="Will be visible on Order Creation"
          >Name (As visible during order creation)</label
        >
      </div>
      <div class="ui-g-8">
        <input pInputText type="text" id="name" [(ngModel)]="customerServiceFee.name" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="feeName">Service Fee Type</label>
      </div>
      <div class="ui-g-8">
        <p-dropdown
          [options]="serviceFeeTypeOptions"
          [(ngModel)]="customerServiceFee.serviceFeeTypeId"
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="feeValue">Fee Value</label>
      </div>
      <div class="ui-g-8">
        <input pInputText type="number" id="feeValue" [(ngModel)]="customerServiceFee.feeValue" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="department">Department</label>
      </div>
      <div class="ui-g-8">
        <p-dropdown
          [options]="deptartmentOptions"
          [(ngModel)]="customerServiceFee.departmentId"
          [style]="{ width: '100%' }"
          (onChange)="handleCustomerDepartmentChange($event.value)"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="team">Team</label>
      </div>
      <div class="ui-g-8">
        <p-dropdown
          [options]="teamOptions"
          [(ngModel)]="customerServiceFee.teamId"
          [style]="{ width: '100%' }"
          (onChange)="handleCustomerTeamChange($event.value)"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="taksLevel">Is Task Level</label>
      </div>
      <div class="ui-g-8">
        <p-checkbox
          name="isTaskLevel"
          [binary]="true"
          [(ngModel)]="customerServiceFee.isTaskLevel"
        ></p-checkbox>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="isMandatory">Mandatory</label>
      </div>
      <div class="ui-g-8">
        <p-checkbox
          name="isMandatory"
          [binary]="true"
          [(ngModel)]="customerServiceFee.isMandatory"
        ></p-checkbox>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button
        type="button"
        pButton
        icon="fa fa-close"
        (click)="displayDialog = false"
        label="Cancel"
        class="ui-btn-secondary"
      ></button>
      <button
        *ngIf="!newCustomerServiceFee"
        type="button"
        pButton
        icon="fa fa-close"
        (click)="delete()"
        label="Delete"
        class="red-btn"
      ></button>
      <button
        type="button"
        pButton
        icon="fa fa-check"
        (click)="save()"
        label="Save"
        class="green-btn"
      ></button>
    </div>
  </p-footer>
</p-dialog>
